import React from "react";
import { Pencil } from "lucide-react";
import { Button } from "components/ui/button";

interface CampaignNodeContentProps {
  name: string;
  subject?: string;
  startDate?: string;
  endDate?: string;
  nodeId: number;
  isEditable?: boolean;
  hideSubject?: boolean;
  onEditNode?: (nodeData: any) => void;
}

const CampaignNodeContent: React.FC<CampaignNodeContentProps> = ({
  name,
  subject,
  startDate,
  endDate,
  nodeId,
  isEditable = true,
  hideSubject = false,
  onEditNode,
}) => {
  const handleEditNode = (e: React.MouseEvent) => {
    e.stopPropagation();
    const nodeData = {
      id: nodeId,
      name,
      subject,
      startDate,
      endDate,
      type: "campaign",
    };
    if (onEditNode) onEditNode(nodeData);
    else console.log("Edit campaign node clicked:", nodeData);
  };

  return (
    <div
      className="campaign-node group relative"
      onContextMenu={(e) => e.preventDefault()}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="node-body">
        <div className="node-row">
          <span className="node-label">Name</span>
          <span className="node-value">{name}</span>
        </div>

        {!hideSubject && subject && (
          <div className="node-row">
            <span className="node-label">Subject</span>
            <span className="node-value">{subject}</span>
          </div>
        )}

        <div className="node-row">
          <span className="node-label">Start</span>
          <span className="node-value">{startDate}</span>
        </div>

        <div className="node-row">
          <span className="node-label">End</span>
          <span className="node-value">{endDate}</span>
        </div>
      </div>

      {isEditable && (
        <Button
          onClick={handleEditNode}
          variant="primary"
          size="icon"
          className="edit-button absolute right-1 -top-10 h-[26px] w-[26px] rounded-full bg-indigo-500 hover:bg-indigo-600 text-white border-2 border-white opacity-0 group-hover:opacity-100 transition-opacity duration-200 shadow-md"
          title="Edit Campaign"
        >
          <Pencil className="h-3 w-3" />
        </Button>
      )}
    </div>
  );
};

export default CampaignNodeContent;
